// extracted by mini-css-extract-plugin
export default {"message":"NamingForm_message__zSG3k","row":"NamingForm_row__JZ7xQ","name":"NamingForm_name__mEA8R","undo":"NamingForm_undo__65-bZ"};